const a = {
  MOBILE: 640,
  TABLET: 768,
  DESKTOP: 1280
}, i = ["en", "fr", "it"], c = ["cms", "destination", "footer", "navigation-bar", "sitemaps", "auth", "search"], u = ["navigation-bar:open-signup-modal"];
function d(t) {
  return new Date(t).toLocaleDateString();
}
function f(t, n) {
  const e = new Date(t);
  return e.setDate(e.getDate() + n), e;
}
function D(t, n) {
  const e = n.getTime() - t.getTime();
  return Math.round(e / (1e3 * 3600 * 24));
}
const m = (t, n) => {
  let e;
  return () => {
    clearTimeout(e), e = setTimeout(t, n);
  };
};
function h(t) {
  window && window.dispatchEvent(new Event(t));
}
function E() {
  return typeof window < "u" && typeof document < "u";
}
const s = (t, n) => t.split(";").map((e) => e.split("=")).filter(([e]) => !n || n.includes(e.trim())).reduce(
  (e, [o, r]) => (e[o.trim()] = r.trim(), e),
  {}
), p = ({ access_token: t, refresh_token: n } = {}) => {
  const e = {}, o = s(document.cookie, ["access_token", "refresh_token"]);
  return e.Authorization = `Bearer ${t ?? o.access_token}`, o.refresh_token && (e.refresh_token = n ?? o.refresh_token), e;
}, w = (t = {}) => {
  const n = {};
  return t.access_token && (n.Authorization = `Bearer ${t.access_token}`), n;
};
export {
  a as BREAKPOINTS,
  u as EVENTS_HE,
  i as LOCALIZED_DOMAINS,
  c as MODULES_HE,
  f as addDaysToDate,
  D as calculateDaysDifference,
  m as debounce,
  h as dispatchEvent,
  d as formatDateToLocale,
  p as getHeaders,
  w as getServerHeaders,
  E as isBrowser,
  s as parseCookies
};
